import EnterpriseHeader from './EnterpriseHeader.component';

export default EnterpriseHeader;
